import { useMemo } from 'react';

import { getActionsSelector } from '@/redux/dialogs/selectors';
import { Dialog } from '@/shared/types/dialog';

import { useDialogsList } from './useDialogsList';

type DialogAction = NonNullable<ReturnType<typeof getActionsSelector>>[number];

const actionIndexes = new WeakMap<Dialog[], Map<string, DialogAction>>();

const getActionIndex = (dialogs: Dialog[]): Map<string, DialogAction> => {
  const cached = actionIndexes.get(dialogs);
  if (cached) {
    return cached;
  }
  const index = new Map(
    (getActionsSelector(dialogs) ?? []).map((action) => [action.action_id, action])
  );
  actionIndexes.set(dialogs, index);
  return index;
};

export const useDialogAction = (actionId?: string): DialogAction | null => {
  const dialogs = useDialogsList();

  return useMemo(() => {
    if (!actionId || !dialogs) {
      return null;
    }
    return getActionIndex(dialogs).get(actionId) ?? null;
  }, [actionId, dialogs]);
};
